var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.localAllActivities),function(activity){return _c('div',{key:activity.id},[_c('ListPanelItem',{staticStyle:{"margin-bottom":"1em"},attrs:{"activity":activity}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }